import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IMenuClass} from '../../../../../core/services/menu/menu.service';
import {IRoute} from "../../../../../core/interfaces/route.interface";
import {IMenuItemForageClass} from "../../../../../core/services/menu/menu-item-forage.service";
import { IMenuItemEcranClass } from '../../../../../core/services/menu/menu-item-ecran.service';

interface IPageRE0001 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Re0001Controller(Menu: IMenuClass,
                                         re0002Route: IRoute,
                                         re0011Route: IRoute,
                                         MenuItemForage: IMenuItemForageClass, 
                                         MenuItemEcran: IMenuItemEcranClass) {
    const vm: IPageRE0001 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },     
        navigatePage: re0002Route.NAME,
        actionsNouveaux: new Menu([
            new MenuItemForage(re0002Route.NAME)
        ]),   
        colonnesVisibles: [
            { nom: 'rtocod', largeur: 90 },
            { nom: 'rtodsc', largeur: 200 },
            { nom: 'rtodatdeb', largeur: 126 },
            { nom: 'rtodatfin', largeur: 126 },
            { nom: 'date_gen', largeur: 126 },
            { nom: 'vaertotyp_dsc', largeur: 120 },
            {
                nom: 'vaertostu_dsc',
                largeur: 120,
                menu: [
                    new MenuItemEcran(
                        'LBL_RESUL', 
                        re0011Route.NAME, 
                        (data: any) => ({ rtocleint: data.rtocleint }), {
                        icon: 'assessment',
                        fonction: 'BOURES',
                        disabled: (data: any) => !['TER', 'ENC'].includes(data.vaertostu)
                    })
                ]
            },
            { nom: 'vaertomodcal_dsc', largeur: 150 },
            { nom: 'rtoflgempnonmod', largeur: 130 }
        ],
        colonnesCachees: ['rtocleint', 'vaertostu']
    };
}
